/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { useState } from 'react';
import {
    array,  object,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Dialog, DialogContent, DialogTitle, Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from 'react-redux';
import GraphqlWineCompliance from '../Partials/GraphqlWineCompliance';
import { getBrand } from '../../../../../../pages/Account/state/ducks/Common/Common-Selectors';
import GraphqlWineRestrictions from '../../CommonProductAgeZipVerify/partials/GraphqlWineRestrictions';

const styles = (theme) => ({
    addonsVerification: {
        maxWidth: '958px',
        borderRadius: 'inherit',
        '& .MuiDialogContent-root': {
            padding: '0px 24px',
        },
    },
    dialogHeader: {
        boxShadow: '0px 3px 3px rgb(47 47 47 / 15%)',
        padding: '10px 20px',
        '& h2': {
            display: 'flex',
            justifyContent: 'space-between',
        },
    },
    headerContent: {
        fontWeight: 700,
        fontSize: '1.25rem',
        letterSpacing: '0.01em',
        margin: 'auto 0',
        '@media screen and (max-width: 768px)': {
            fontSize: '1rem',
        },
    },
    closeIcon: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 'auto 0',
        float: 'right',
    },
    selectedContainer: {
        boxShadow: '0px 0px 0px 2px rgb(44 128 19)',
        width: '73px',
        height: '75px',
        marginLeft: '-1px',
        display: 'flex',
    },
    dialogContent: {
        '& button': {
            color: theme.palette.primary.main || '#2F2F2F',
            fontWeight: 700,
        },
    },
});

const WineInformation =  (
    {
        selectAddons,
        classes,
    },
) => {
    const [open, setOpen]  = useState(false);
    const brand = useSelector(getBrand);
    const [triggerTastingRestrictionsModal, setTriggerTastingRestrictionsModal]  = useState(false);
    const  handleTastingRestrictionsModal = (flag) => {
        setTriggerTastingRestrictionsModal(flag);
    };
    const wineProduct = selectAddons?.some((item) => item.ageVerifyFlag === true);
    return (
        <>
            {wineProduct && (
                <Typography
                    className={classes.wineInfo}
                    role="button"
                    onClick={() => setOpen(true)}
                    onKeyDown={() => setOpen(true)}
                    tabIndex={0}
                >
                    Information about wine purchases
                </Typography>
            ) }

            <Dialog
                PaperProps={{
                    className: classes.addonsVerification,
                }}
                open={open}
                maxWidth="xs"
                onClose={() => { setOpen(false); }}
            >

                <DialogTitle className={classes.dialogHeader}>
                    <span className={classes.headerContent}>WINE PURCHASE INFO</span>
                    <span role="presentation" onClick={() => { setOpen(false); }}>
                        <CloseIcon className={classes.closeIcon} />
                    </span>
                </DialogTitle>
                <DialogContent data-testid="wine-compliance-content" className={classes.dialogContent}>
                    <GraphqlWineCompliance brand={brand} handleTastingRestrictionsModal={handleTastingRestrictionsModal} />
                </DialogContent>
            </Dialog>
            <Dialog
                PaperProps={{
                    className: classes.addonsVerification,
                }}
                open={triggerTastingRestrictionsModal}
                maxWidth="xs"
                onClose={() => { setTriggerTastingRestrictionsModal(false); }}
            >
                <DialogContent data-testid="tasting-restrictions-modal-content" className={classes.dialogContent}>
                    <span role="presentation" onClick={() => { setTriggerTastingRestrictionsModal(false); }}>
                        <CloseIcon className={classes.closeIcon} />
                    </span>
                    <div className={classes.wineContainer} data-testid="wine-shipping-details">
                        <h4 className={classes.wineHeader}>WINE SHIPPING DETAILS</h4>
                        <GraphqlWineRestrictions path="/h/view/wineship" />
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

WineInformation.propTypes = {
    classes: object.isRequired,
    selectAddons: array,
};

WineInformation.defaultProps = {
    selectAddons: [],
};

export default (withStyles(styles)(WineInformation));
